import { Colors } from 'axl-reactjs-ui';
import styled from "styled-components";

export const FooterContainer = styled.div`
  > * {
    flex-grow: 1;
    flex-shrink: 0;
  }
`;

export default {
    container: {
        paddingBottom: '50px',
        textAlign: 'left',
        position: 'relative',
        backgroundColor: '#FFF',
        height: 'calc(100% - 50px)'
    },
    statusBox: {
        float: 'right'
    },
    body: {
        position: 'absolute',
        bottom: '50px',
        left: 0,
        right: 0,
        top: 0
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '50px',
        boxSizing: 'border-box',
        padding: '4px 10px 4px 10px',
        backgroundColor: Colors.veryLightGrey,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'auto',
        zIndex: 1
    },
    groupButtons: {
        minWidth: 85
    },
    modalContainer: {
        display: 'flex'
    },
    modalStyle: {
        width: '480px',
        display: 'block',
        overflow: 'initial',
        backgroundColor: 'transparent',
        margin: 'auto',
        boxShadow: 'none'
    },
    modalImageStyle: {
        width: '650px',
        backgroundColor: '#FFF',
        padding: '30px 0'
    },
    modalShipmentCancel: {
        width: '500px'
    },
    modalFeedback: {
        width: '600px',
        padding: 0,
    },
    wrapImages: {
        width: '100%',
        height: '100%',
        textAlign: 'center',
        position: 'relative',
        zIndex: 999
    },
    imageShipment: {
        width: 'auto',
        maxWidth: '100%',
        // maxHeight: '100%',
        maxHeight: 'calc(100vh - 100px)',
        margin: 'auto',
        backgroundColor: '#FFFF'
    },
    arrowButton: {
        width: '30px',
        height: '30px',
        backgroundColor: '#000',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        bottom: 0,
        margin: 'auto',
        zIndex: 10000,
        cursor: 'pointer'
    },
    arrowPrev: {
        left: 0
    },
    arrowNext: {
        right: 0
    },
    arrowIcon: {
      fontSize: '25px',
      color: '#fff'
    }
}
